import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'


const NewCaseView = lazy(() => import('./NewCases.jsx'))
const SingleCaseView = lazy(() => import('./CaseTabs/CaseSingleCaseView.jsx'))
const ActivitiesTakenPage = lazy(() => import('./ActivitiesTakenPage.jsx'))


const CaseOfficerCaseManagementRoutes = [
    {
        path: '/CaseOfficerCasesManagement',
        component: NewCaseView,
        auth: authRoleAccess.case_officer_case_management,
    },
    {
        path: '/org-case-officer/:id',
        component: SingleCaseView,
        auth: authRoleAccess.case_officer_case_management,
    },

    {
        path: '/ActivitiesTakenPage/:id',
        component: ActivitiesTakenPage,
        auth: authRoleAccess.case_officer_case_management,
    },


]

export default CaseOfficerCaseManagementRoutes
